/* Club Valais — points hydration.
   The balance lives behind Appstle and is only available client-side; the
   customer metafield appstle_loyalty.customer_loyalty has storefront access
   NONE, so Liquid cannot read it. Tier is server-rendered from customer.tags.

   Rules that drive this file:
   - never render "0 punten" as a loading value (a real 0 only shows once
     we know the customer genuinely has none)
   - reserve height so hydration causes no layout shift
   - on failure keep the static page and say so quietly */
(function () {
  var wortel = document.querySelector('[data-club]');
  if (!wortel) return;

  var INGELOGD = wortel.getAttribute('data-club-ingelogd') === '1';
  if (!INGELOGD) return;                       // state A: nothing to fetch

  /* Layer 1 (free member, no tier) runs from 0 to the Matterhorn threshold.
     A member without a tier is not tier-less in tone — they are on their way
     to the first tier, so progress is always framed forwards. */
  var DREMPELS = [
    { sleutel: 'matterhorn',   naam: 'Matterhorn',   punten: 300 },
    { sleutel: 'weisshorn',    naam: 'Weisshorn',    punten: 500 },
    { sleutel: 'dufourspitze', naam: 'Dufourspitze', punten: 1000 }
  ];

  function toon(el) { if (el) el.hidden = false; }
  function verberg(el) { if (el) el.hidden = true; }

  function skeletonsWeg() {
    document.querySelectorAll('[data-club-skeleton]').forEach(function (s) { s.remove(); });
  }

  function schrijf(saldo) {
    var heeft = typeof saldo === 'number' && !isNaN(saldo);
    skeletonsWeg();

    document.querySelectorAll('[data-club-punten]').forEach(function (el) {
      if (!heeft) return;
      el.textContent = saldo.toLocaleString('nl-NL') + ' punten';
      toon(el);
    });

    if (!heeft) return;

    // progress to the next tier
    var volgende = null;
    for (var i = 0; i < DREMPELS.length; i++) {
      if (saldo < DREMPELS[i].punten) { volgende = DREMPELS[i]; break; }
    }
    document.querySelectorAll('[data-club-voortgang]').forEach(function (el) {
      if (volgende) {
        el.textContent = 'Nog ' + (volgende.punten - saldo).toLocaleString('nl-NL') + ' punten tot ' + volgende.naam;
      } else {
        el.textContent = 'Je hebt het hoogste niveau bereikt.';
      }
      toon(el);
    });

    // mark the position on the mountain
    var hoogste = DREMPELS[DREMPELS.length - 1].punten;
    var pct = Math.max(0, Math.min(100, Math.round((saldo / hoogste) * 100)));
    document.querySelectorAll('[data-club-marker]').forEach(function (el) {
      el.style.setProperty('--club-positie', pct + '%');
      el.setAttribute('data-club-positie', String(pct));
    });

    // which rewards are within reach
    document.querySelectorAll('[data-club-kosten]').forEach(function (kaart) {
      var kosten = parseInt(kaart.getAttribute('data-club-kosten'), 10);
      if (isNaN(kosten)) return;
      var haalbaar = saldo >= kosten;
      kaart.classList.toggle('is-haalbaar', haalbaar);
      var melding = kaart.querySelector('[data-club-haalbaar]');
      if (melding) {
        melding.textContent = haalbaar
          ? 'Je kunt dit nu inwisselen'
          : 'Nog ' + (kosten - saldo).toLocaleString('nl-NL') + ' punten';
        toon(melding);
      }
    });

    /* State D covers every logged-in customer without a tier tag — the most
       common state. A genuine zero is a sub-case of that, not of loading. */
    var heeftTier = wortel.getAttribute('data-club-tier') !== 'none';
    var status = heeftTier ? 'lid' : (saldo === 0 ? 'nieuw' : 'vrij-lid');
    wortel.setAttribute('data-club-status', status);

    document.querySelectorAll('[data-club-welkom]').forEach(function (el) {
      if (status === 'nieuw') { el.hidden = false; }
    });
  }

  function mislukt(reden) {
    skeletonsWeg();
    document.querySelectorAll('[data-club-fout]').forEach(toon);
    wortel.setAttribute('data-club-status', 'onbekend');
    if (window.console) console.warn('[Club Valais] puntensaldo niet opgehaald:', reden);
  }

  /* Appstle exposes the balance on window._ALConfig once its widget has
     initialised. It loads asynchronously, so poll briefly instead of
     assuming it is ready. */
  function leesSaldo() {
    var c = window._ALConfig;
    if (!c) return null;
    var kandidaten = [
      c.customerPoints, c.availablePoints, c.points,
      c.customerLoyalty && c.customerLoyalty.availablePoints,
      c.loyaltyCustomer && c.loyaltyCustomer.availablePoints
    ];
    for (var i = 0; i < kandidaten.length; i++) {
      if (typeof kandidaten[i] === 'number') return kandidaten[i];
    }
    return null;
  }

  var pogingen = 0;
  var timer = setInterval(function () {
    pogingen++;
    var saldo = leesSaldo();
    if (saldo !== null) { clearInterval(timer); schrijf(saldo); return; }
    if (pogingen >= 25) {                       // ~10s
      clearInterval(timer);
      viaProxy();
    }
  }, 400);

  /* Fallback: Appstle's app proxy. Returns the loyalty record for the
     logged-in customer without needing the widget. */
  function viaProxy() {
    var prefix = (window._ALConfig && window._ALConfig.proxy_path_prefix) || 'apps/loyalty';
    fetch('/' + prefix + '/api/customer', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) {
        var saldo = d && (d.availablePoints ?? d.points ?? (d.customer && d.customer.availablePoints));
        if (typeof saldo === 'number') schrijf(saldo);
        else mislukt('onverwacht antwoord van de proxy');
      })
      .catch(mislukt);
  }
})();
